"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const enums_1 = require("../enums");
class EndpointsService {
    constructor(endpoints, instanceId) {
        this.endpoints = {
            baseUrl: '',
            servicesUrls: {
                [enums_1.ServiceTypeEnum.SEARCH]: '/search',
                [enums_1.ServiceTypeEnum.BROWSE]: '/browse',
                [enums_1.ServiceTypeEnum.ATTRIBUTES]: '/attributes'
            }
        };
        this.endpoints = {
            baseUrl: `${endpoints.baseUrl}/${instanceId}`,
            servicesUrls: Object.assign(this.endpoints.servicesUrls, endpoints.servicesUrls)
        };
    }
    getServiceUrl(serviceType) {
        const servicesUrls = this.endpoints.servicesUrls;
        let serviceUrl = servicesUrls[serviceType];
        if ((serviceType === enums_1.ServiceTypeEnum.SEARCH_BOOST) && !servicesUrls[serviceType]) {
            serviceUrl = servicesUrls[enums_1.ServiceTypeEnum.SEARCH];
        }
        return `${this.endpoints.baseUrl}${serviceUrl}`;
    }
}
exports.EndpointsService = EndpointsService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5kcG9pbnRzLnNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VydmljZXMvZW5kcG9pbnRzLnNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxvQ0FBMkM7QUFJM0MsTUFBYSxnQkFBZ0I7SUFXM0IsWUFBWSxTQUFvQixFQUFFLFVBQWtCO1FBVG5DLGNBQVMsR0FBYztZQUN0QyxPQUFPLEVBQUUsRUFBRTtZQUNYLFlBQVksRUFBRTtnQkFDWixDQUFDLHVCQUFlLENBQUMsTUFBTSxDQUFDLEVBQUUsU0FBUztnQkFDbkMsQ0FBQyx1QkFBZSxDQUFDLE1BQU0sQ0FBQyxFQUFFLFNBQVM7Z0JBQ25DLENBQUMsdUJBQWUsQ0FBQyxVQUFVLENBQUMsRUFBRSxhQUFhO2FBQzVDO1NBQ0YsQ0FBQztRQUdBLElBQUksQ0FBQyxTQUFTLEdBQUc7WUFDZixPQUFPLEVBQUUsR0FBSSxTQUFTLENBQUMsT0FBUSxJQUFLLFVBQVcsRUFBRTtZQUNqRCxZQUFZLEVBQUUsTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFlBQVksRUFBRSxTQUFTLENBQUMsWUFBWSxDQUFDO1NBQ2pGLENBQUM7SUFDSixDQUFDO0lBRU0sYUFBYSxDQUFDLFdBQTRCO1FBQy9DLE1BQU0sWUFBWSxHQUFRLElBQUksQ0FBQyxTQUFTLENBQUMsWUFBWSxDQUFDO1FBQ3RELElBQUksVUFBVSxHQUFHLFlBQVksQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUMzQyxJQUFJLENBQUMsV0FBVyxLQUFLLHVCQUFlLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQyxZQUFZLENBQUMsV0FBVyxDQUFDLEVBQUU7WUFDaEYsVUFBVSxHQUFHLFlBQVksQ0FBQyx1QkFBZSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1NBQ25EO1FBQ0QsT0FBTyxHQUFJLElBQUksQ0FBQyxTQUFTLENBQUMsT0FBUSxHQUFJLFVBQVcsRUFBRSxDQUFDO0lBQ3RELENBQUM7Q0FFRjtBQTNCRCw0Q0EyQkMifQ==